module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp1_3009.408548e3.png";